/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DSlugRouteImport } from './routes/d.$slug'
import { Route as PDeckRouteImport } from './routes/p.$deck'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DSlugRoute = DSlugRouteImport.update({
  id: '/d/$slug',
  path: '/d/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const PDeckRoute = PDeckRouteImport.update({
  id: '/p/$deck',
  path: '/p/$deck',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/d/$slug': typeof DSlugRoute
  '/p/$deck': typeof PDeckRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/d/$slug': typeof DSlugRoute
  '/p/$deck': typeof PDeckRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/d/$slug': typeof DSlugRoute
  '/p/$deck': typeof PDeckRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/d/$slug' | '/p/$deck'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/d/$slug' | '/p/$deck'
  id: '__root__' | '/' | '/d/$slug' | '/p/$deck'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DSlugRoute: typeof DSlugRoute
  PDeckRoute: typeof PDeckRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/d/$slug': {
      id: '/d/$slug'
      path: '/d/$slug'
      fullPath: '/d/$slug'
      preLoaderRoute: typeof DSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/p/$deck': {
      id: '/p/$deck'
      path: '/p/$deck'
      fullPath: '/p/$deck'
      preLoaderRoute: typeof PDeckRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DSlugRoute: DSlugRoute,
  PDeckRoute: PDeckRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
